import {
  Adjustments,
  Briefcase,
  Edit,
  Home,
  Plus,
  Search,
} from "tabler-icons-react";
import routeNames from "../../../routes/routeNames";

export const links = [
  {
    label: "Dashboard",
    link: routeNames.employer.dashboard,
    icon: <Home color="white" />,
  },
  {
    label: "Post a Job",
    link: routeNames.employer.postAJob,
    icon: <Plus color="white" />,
  },
  {
    label: "My Jobs",
    link: routeNames.employer.myJobs,
    icon: <Briefcase color="white" />,
  },
  {
    label: "Search People",
    link: routeNames.employer.searchJokSeeker,
    icon: <Search color="white" />,
  },
];
export const internalLinks = [
  {
    label: "Edit Profile",
    link: routeNames.employer.myProfile,
    icon: <Edit size={22} />,
  },
  {
    label: "Settings",
    link: routeNames.employer.settings,
    icon: <Adjustments size={22} />,
  },
];
